import { StoryblokLink } from '@/components/shared/storyblok-link'
import { Button } from '@/components/ui/button'
import { NavigationMenuLink } from '@/components/ui/navigation-menu'
import type { GlobalNavSubMenuColLatestReleaseStoryblok } from '@/lib/types/component-types-sb'
import { ChevronRight } from 'lucide-react'
import { NavSubMenuLatestRelease } from './nav-sub-menu-latest-release'

export function NavSubMenuColLatestRelease({
  col,
}: {
  col: GlobalNavSubMenuColLatestReleaseStoryblok
}) {
  return (
    <NavigationMenuLink
      asChild
      key={col._uid}
    >
      <div className="space-y-2">
        <div className="flex items-center justify-between px-2.5">
          <span className="text-muted-foreground text-sm font-medium">{col.title}</span>
          <Button
            variant="link-brand"
            size="sm"
            asChild
            className="gap-0 px-0"
          >
            <StoryblokLink
              prefetch={true}
              link={col.target}
            >
              Read more <ChevronRight className="text-brand" />
            </StoryblokLink>
          </Button>
        </div>
        <NavSubMenuLatestRelease col={col} />
      </div>
    </NavigationMenuLink>
  )
}
